import React from "react";
import { useSearch } from "wouter";

// ai candy club -> nectar roleplay
const NectarRoleplayPage = () => {
  const search = useSearch();
  const searchParams = new URLSearchParams(search);
  const mode = searchParams.get("mode") || "realistic";

  return (
    <div className="min-h-screen relative overflow-hidden">
      <div
        className="w-full min-h-screen flex relative overflow-hidden"
        style={{
          backgroundImage: "url('/assets/aicandyclub/main_background.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Background decorative elements */}
        <div className="absolute inset-0 opacity-20">
          {/* Large lollipop swirls - responsive positioning */}
          <div className="absolute top-4 right-4 md:top-10 md:right-10 w-20 h-20 md:w-40 md:h-40 bg-gradient-to-br from-pink-200 to-white rounded-full opacity-30 transform rotate-12"></div>
          <div className="absolute top-8 left-4 md:top-20 md:left-20 w-16 h-16 md:w-32 md:h-32 bg-gradient-to-br from-pink-200 to-white rounded-full opacity-30 transform -rotate-6"></div>
          <div className="absolute bottom-8 right-1/4 w-18 h-18 md:w-36 md:h-36 bg-gradient-to-br from-pink-200 to-white rounded-full opacity-30 transform rotate-45"></div>

          {/* Smaller candy pieces */}
          <div className="absolute top-1/3 left-1/4 w-8 h-8 md:w-16 md:h-16 bg-gradient-to-br from-pink-100 to-white rounded-full opacity-40"></div>
          <div className="absolute bottom-1/3 right-1/3 w-6 h-6 md:w-12 md:h-12 bg-gradient-to-br from-pink-100 to-white rounded-full opacity-40"></div>
          <div className="absolute top-2/3 left-1/3 w-10 h-10 md:w-20 md:h-20 bg-gradient-to-br from-pink-100 to-white rounded-full opacity-40"></div>
        </div>

        {/* Side Images - Hidden on mobile, visible on larger screens */}
        <img
          src={`/assets/aicandyclub/${mode}/girl_left.png`}
          alt="Girl Left"
          className="hidden lg:block absolute left-0 bottom-0 h-[75vh] xl:h-[85vh] 2xl:h-[95vh] max-h-[1000px] z-10 object-contain pointer-events-none"
        />
        <img
          src={`/assets/aicandyclub/${mode}/girl_right.png`}
          alt="Girl Right"
          className="hidden lg:block absolute right-0 bottom-0 h-[75vh] xl:h-[85vh] 2xl:h-[95vh] max-h-[1000px] z-10 object-contain pointer-events-none"
        />

        {/* Main content */}
        <div className="relative z-20 flex flex-col min-h-screen w-full">
          {/* Main content area */}
          <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8">
            <div className="max-w-4xl mx-auto w-full">
              <div className="flex flex-col items-center text-center space-y-6 md:space-y-8">
                {/* Circular video element - responsive sizing */}
                <div className="relative w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 lg:w-56 lg:h-56">
                  <div className="rounded-full overflow-hidden w-full h-full">
                    <img
                      src={`/assets/aicandyclub/${mode}/girl_gif_1.gif`}
                      alt="AI Character"
                    />
                  </div>
                </div>

                {/* Main headline - responsive text sizing */}
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight font-poppins px-4">
                  Create the AI
                  <br />
                  <span className="text-pink-100">of your Dreams</span>
                </h1>

                {/* Call to action button - responsive sizing */}
                <a
                  href={`/?mode=${mode}`}
                  className="text-[#ff4747] bg-white rounded-full justify-center items-center px-8 sm:px-12 md:px-16 lg:px-20 py-4 sm:py-5 md:py-6 lg:py-8 no-underline flex font-bold text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl hover:bg-pink-50 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 font-poppins"
                >
                  Try For Free
                </a>
              </div>
            </div>
          </main>

          {/* Footer - responsive layout */}
          <footer
            className="py-6 md:py-8"
            style={{
              backgroundImage: "url('/assets/aicandyclub/main_background.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-center">
                {/* Left - Google Score */}
                <div className="flex flex-col items-center md:items-start">
                  <span className="text-white font-semibold text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-2 md:mb-4 font-poppins">
                    Google Score
                  </span>
                  <div className="flex w-32 sm:w-40 md:w-48 lg:w-[200px]">
                    <img
                      src="https://cdn.prod.website-files.com/65f19e548e3e35c939145062/65f1c583c60b4228dfcc9703_Frame%20303.png"
                      className="w-full"
                      alt="Google Score"
                    />
                  </div>
                </div>

                {/* Center - Logo */}
                <div className="flex justify-center">
                  <a href="#" className="flex items-center">
                    <p className="text-white font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">
                      Nectar
                    </p>
                    <p className="text-[#ff4747] font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">
                      AI
                    </p>
                  </a>
                </div>

                {/* Right - Payment methods */}
                <div className="flex flex-col items-center md:items-end">
                  <span className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-2 md:mb-4 font-medium font-poppins">
                    Secured Payment.
                  </span>
                  <div className="flex w-32 sm:w-40 md:w-48 lg:w-[225px]">
                    <img
                      src="https://cdn.prod.website-files.com/65f19e548e3e35c939145062/65f1c583c60b4228dfcc9707_Frame%20169.png"
                      className="w-full"
                      loading="lazy"
                      alt="Payment Methods"
                    />
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default NectarRoleplayPage;
